<template>
	<div class="container mt-4">
    <div class="mt-3 row justify-content-center">
      <div class="col-md-10 col-12">
        <div class="d-flex justify-content-between mb-3">
          <a @click.prevent="$router.back()" class="btn btn-secondary" ><i class="fas fa-arrow-left"></i> Retour</a>
        </div>
        <div class="d-flex justify-content-center">
          <RecapNote v-if="expense" :expense="expense" :rawexpense="rawExpenses"></RecapNote>
          <a v-if="expense" :href="urlfullimage" target="_blank">
            <img v-if="!isPdf" :src="urlimage" alt="ticket" class="img-fluid">
            <span v-else class="btn btn-outline-secondary">
              <i class="far fa-file-pdf me-1"></i> Ouvrir le justificatif PDF
            </span>
          </a>
          </div>
      </div>
      <!-- bouton pour supprimer la note de frais -->
      <div class="d-flex justify-content-center mt-3" v-if="isDeletable">
        <n-popconfirm positive-text="Oui" negative-text="Non" @positive-click="deleteTicket">
          <template #trigger>
            <n-button type="error" size="small">
              <i class="fas fa-trash"></i> Supprimer la note de frais
            </n-button>
          </template>
          Es tu sûr de vouloir supprimer la note de frais ?
        </n-popconfirm>
      </div>
    </div>

  </div>
</template>
<script>
import moment from 'moment';
import {formatDateTime, formatDate} from '../../plugins/helpers.js'
import {mapGetters} from "vuex";
import RecapNote from "./RecapNote.vue";

moment.locale('fr');

export default {
  components: {
    RecapNote
  },
  data() {
    return {
      rawExpenses: {},
      expense: null,
      displayImage: false,
    }
  },

  beforeMount : async function () {
    const pb = this.getPb;
    console.log(this.$router.currentRoute.value.params.id);

    try{

      this.rawExpenses = await pb.collection('expense').getOne(this.$router.currentRoute.value.params.id);
      console.log(this.rawExpenses, 'rawExpenses');

      this.expense = this.rawExpenses.raw;
      this.expense.id = this.rawExpenses.id;

    } catch (e) {
      console.log(e);
    }

  },
  computed: {
    ...mapGetters(['getPb']),
    isDeletable() {
      return this.rawExpenses.exported_at == null || this.rawExpenses.exported_at == '';
    },
    urlimage() {
      return  this.getPb.files.getUrl(this.rawExpenses, this.rawExpenses.picture, {'thumb': '200x0'});
    },
    urlfullimage() {
      return  this.getPb.files.getUrl(this.rawExpenses, this.rawExpenses.picture);
    },
    isPdf() {
      return typeof this.rawExpenses.picture === 'string' && this.rawExpenses.picture.toLowerCase().endsWith('.pdf');
    },
  },
  methods: {
    formatDateTime,
    formatDate,
    libelle(value) {
      switch (value) {
        case 'fuel':
          return 'Carburant';
        case 'restaurant':
          return 'Restaurant Interne';
        case 'restaurantclient':
          return 'Restaurant Client';
        case 'transportation':
          return 'Transport';
        case 'misc':
          return 'Divers';
        default:
          return '';
      }
    },
    deleteTicket : async function () {
      await this.$store.dispatch('deleteTicket', this.expense.id);
      this.$router.push({name: 'expenses'});
    }
  }
}
</script>